import React, { useState } from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Commissions from './Commissions';
import DailyLeadLog from './DailyLeadLog';
import DesignerAnalysis from './DesignerAnalysis';
import Form from 'react-bootstrap/Form';
import MonthlyAdvertising from './MonthlyAdvertising';
import MonthlyBusiness from './MonthlyBusiness';
import MonthlyInstallations from './MonthlyInstallation';
import Row from 'react-bootstrap/Row';
import SelectList from '../shared/inputs/SelectList';
import useFilter from '../../utilities/useFilter';
import MiscSaleReport from './MiscSaleReport';

const ReportView = () => {
    const [currentView, setCurrentView] = useState(1);

    const today = new Date();

    const defaultFilter = {
        franchiseId: window.biztrax.franchiseId,
        dateFrom: new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0],
        dateTo: new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0]
    };

    const { submitFilter, ...searchHook } = useFilter('',
        currentView === 'MonthlyInstallations'
        ? { ...defaultFilter, sortColumn: 'InstallDate' }
        : defaultFilter);

    const changeView = ({ target: { value } }) => {
        if (currentView !== value) {
            searchHook.setUrl('');
            setCurrentView(value);
        }
    }

    const switchView = () => {
        switch (currentView) {
            case 'DailyLeadLog':
                return <DailyLeadLog {...searchHook} />;
            case 'MonthlyBusiness':
                return <MonthlyBusiness {...searchHook} />;
            case 'MiscSaleReport':
                return <MiscSaleReport {...searchHook} />;
            case 'MonthlyAdvertising':
                return <MonthlyAdvertising {...searchHook} />;
            case 'DesignerAnalysis':
                return <DesignerAnalysis {...searchHook} />;
            case 'Commissions':
                return <Commissions {...searchHook} />;
            case 'MonthlyInstallations':
                return <MonthlyInstallations {...searchHook} />;
            default:
                return <DailyLeadLog {...searchHook} />;
        }
    }

    return (
        <Row>
            <Col>
                <div className="report-selector">
                    <Row>
                        <Form.Group as={Col} sm={6} md={'auto'}>
                            <Form.Label className="col-form-label-sm">
                                Select Report
                            </Form.Label>
                            <SelectList
                                onChange={changeView}
                                value={currentView}
                            >
                                <option value="DailyLeadLog">Daily Lead Log</option>
                                <option value="MonthlyBusiness">Monthly Business Sold</option>
                                <option value="MiscSaleReport">Misc Sales</option>
                                <option value="MonthlyAdvertising">Monthly Advertising</option>
                                <option value="DesignerAnalysis">Designer Analysis</option>
                                <option value="Commissions">Commissions</option>
                                <option value="MonthlyInstallations">Monthly Installations/AR</option>
                            </SelectList>
                        </Form.Group>
                        {window.biztrax.franchiseId === 1 &&
                            <Form.Group as={Col} sm={6} md={'auto'}>
                                <Form.Label className="col-form-label-sm">
                                    Franchise
                                </Form.Label>
                                <SelectList
                                    lookupType="Franchise"
                                    name="franchiseId"
                                    onChange={searchHook.setFilter}
                                    value={searchHook.filter.franchiseId}
                                    options={[{id:0, name:'All'}]}
                                >
                                </SelectList>
                            </Form.Group>
                        }
                        <Col md>
                            <Row className="justify-content-around justify-content-md-end pt-md-3">
                                <Col xs={'auto'}>
                                    <Button
                                        onClick={submitFilter}
                                        style={{ width: '100px' }}
                                        variant="info"
                                    >Run</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div>
                    {switchView()}
                </div>
            </Col>
        </Row>
    );
}

export default ReportView;